import React, { useEffect, useState, createElement } from 'react';
import { motion } from 'framer-motion';
import { Check, ShieldCheck, CreditCard, Users, BookOpen, Clock, Zap, AlertTriangle, ChevronDown, Star } from 'lucide-react';
import { CountdownTimer } from './components/CountdownTimer';
import { PurchaseNotification } from './components/PurchaseNotification';
import { TestimonialCard } from './components/TestimonialCard';
export function App() {
  // Top bar countdown timer (15 minutes)
  const [topBarTime, setTopBarTime] = useState({
    minutes: 15,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTopBarTime(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else {
          // Reset when reaches 0
          return {
            minutes: 15,
            seconds: 0
          };
        }
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  // Facebook Meta Pixel - Safe implementation with null checks
  useEffect(() => {
    // Inject Meta Pixel Code with proper error handling
    ;
    (function (f: any, b: Document, e: string, v: string, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      // Safe insertion with null check
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        // Fallback: append to head if no script tags exist
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    (window as any).fbq('init', '905280231851143');
    (window as any).fbq('track', 'PageView');
    // Add noscript fallback image safely
    if (document.body) {
      const noscript = document.createElement('noscript');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = 'https://www.facebook.com/tr?id=905280231851143&ev=PageView&noscript=1';
      noscript.appendChild(img);
      document.body.appendChild(noscript);
    }
  }, []);
  const scrollToPurchase = () => {
    const element = document.getElementById('purchase');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const formatTime = (minutes: number, seconds: number) => {
    return `00:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };
  return <div className="min-h-screen bg-white font-sans text-gray-900 overflow-x-hidden" data-id="element-0">
      <PurchaseNotification data-id="element-1" />

      {/* Top Bar Urgency - Fixed with countdown and smaller text */}
      <div className="bg-[#FF6B35] text-white text-center py-1 px-4 font-bold text-xs sticky top-0 z-40 shadow-md" data-id="element-2">
        ⚡ OFERTA EXPIRA EN:{' '}
        <span className="font-mono" data-id="element-3">
          {formatTime(topBarTime.minutes, topBarTime.seconds)}
        </span>{' '}
        | SOLO QUEDAN 3 CUPOS
      </div>

      {/* HERO SECTION - Optimized for mobile */}
      <section className="pt-2 pb-3 px-4 md:px-8 max-w-6xl mx-auto text-center" data-id="element-4">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-5">
          <span className="inline-block bg-yellow-100 text-yellow-800 px-3 py-1 rounded-full font-bold text-xs mb-2 border border-yellow-300" data-id="element-6">
            🇬🇧📚 MEGAPACK INGLÉS LISTO™
          </span>
          <h1 className="text-2xl md:text-6xl font-black text-gray-900 leading-tight mb-2" data-id="element-7">
            Todo tu año de Inglés resuelto.
          </h1>
          <p className="text-base md:text-2xl text-gray-600 mb-2 max-w-3xl mx-auto" data-id="element-8">
            Sin improvisar. Sin perder horas. Sin estrés.
          </p>

          {/* Main Product Image - Slightly increased size */}
          <div className="relative mb-2 group cursor-pointer" onClick={scrollToPurchase} data-id="element-9">
            <div className="absolute inset-0 bg-orange-500 blur-3xl opacity-20 rounded-full transform scale-75" data-id="element-10"></div>
            <img src="https://cdn.magicpatterns.com/uploads/9c8hrkXpSozfYYYiQNkFPZ/PROYECTOS_Anuales_(11).png" alt="Megapack Inglés Listo Product Box" className="relative mx-auto w-full max-w-[270px] md:max-w-lg hover:scale-105 transition-transform duration-300" data-id="element-11" />
          </div>

          <div className="bg-gray-50 border-2 border-dashed border-gray-300 rounded-xl p-3 md:p-6 max-w-3xl mx-auto mb-2" data-id="element-12">
            <p className="text-sm md:text-xl font-medium text-gray-800 mb-2" data-id="element-13">
              Con el sistema definitivo de material de INGLÉS ahorraras hasta un
              año de preparación de contenido para tus clases.
            </p>
            <div className="flex flex-wrap justify-center gap-2 md:gap-4 text-xs md:text-base font-bold text-gray-700" data-id="element-14">
              <span className="flex items-center" data-id="element-15">
                <Users className="w-4 h-4 md:w-5 md:h-5 mr-1 text-[#FF6B35]" data-id="element-16" />{' '}
                +2.847 docentes activos
              </span>
              <span className="flex items-center" data-id="element-17">
                <Star className="w-4 h-4 md:w-5 md:h-5 mr-1 text-[#FF6B35] fill-current" data-id="element-18" />{' '}
                5.0★ valoración
              </span>
              <span className="flex items-center" data-id="element-19">
                <BookOpen className="w-4 h-4 md:w-5 md:h-5 mr-1 text-[#FF6B35]" data-id="element-20" />{' '}
                +380 Worksheets
              </span>
            </div>
          </div>

          <button onClick={scrollToPurchase} className="bg-[#FF6B35] hover:bg-[#ff5514] text-white text-base md:text-3xl font-black py-3 md:py-6 px-6 md:px-12 rounded-lg shadow-[0_6px_0_rgb(180,60,20)] hover:shadow-[0_3px_0_rgb(180,60,20)] hover:translate-y-[3px] transition-all w-full md:w-auto mb-2 animate-pulse" data-id="element-21">
            👉 QUIERO MI ACCESO AHORA
            <span className="block text-xs md:text-sm font-normal mt-1 opacity-90" data-id="element-22">
              (SOLO 3 CUPOS)
            </span>
          </button>

          <div className="flex items-center justify-center gap-2 text-xs md:text-sm text-gray-500" data-id="element-23">
            <ShieldCheck className="w-4 h-4" data-id="element-24" />
            Garantía de satisfacción de 7 días
          </div>
        </motion.div>
      </section>

      {/* PROBLEM / AGITATION */}
      <section className="py-16 bg-gray-50 px-4" data-id="element-25">
        <div className="max-w-4xl mx-auto" data-id="element-26">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-27">
            Si sos docente de Inglés, esto te va a resultar demasiado familiar…
          </h2>

          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-28">
            <div className="space-y-4 text-lg text-gray-700" data-id="element-29">
              <p data-id="element-30">Llegás a tu casa cansado/a…</p>
              <p data-id="element-31">Sabés que tenés que planificar…</p>
              <p data-id="element-32">Abrís la compu…</p>
              <p className="font-bold text-red-600" data-id="element-33">
                Y empezás otra vez desde cero.
              </p>
              <p data-id="element-34">
                Buscando worksheets. Buscando actividades. Buscando textos
                adecuados. Buscando juegos que funcionen.
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-lg border-l-8 border-red-500" data-id="element-35">
              <h3 className="text-2xl font-bold mb-4 flex items-center" data-id="element-36">
                <AlertTriangle className="w-8 h-8 text-red-500 mr-3" data-id="element-37" />
                El problema real
              </h3>
              <p className="mb-4" data-id="element-38">El sistema educativo hoy te exige:</p>
              <ul className="space-y-2 mb-6" data-id="element-39">
                {['Planificar clases', 'Crear material', 'Adaptarte a distintos niveles', 'Motivar alumnos', 'Evaluar', 'Resolver sobre la marcha'].map(item => <li key={item} className="flex items-center text-gray-700" data-id="element-40">
                    <span className="w-2 h-2 bg-red-400 rounded-full mr-3" data-id="element-41"></span>
                    {item}
                  </li>)}
              </ul>
              <p className="font-bold text-gray-900" data-id="element-42">
                ❌ Y nadie te dio un sistema que te ahorre ese trabajo.
              </p>
            </div>
          </div>

          <div className="mt-12 bg-gray-800 text-white p-8 rounded-xl text-center" data-id="element-43">
            <h3 className="text-2xl font-bold mb-6" data-id="element-44">Vivís así:</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-45">
              <div className="bg-gray-700 p-4 rounded-lg" data-id="element-46">
                Improvisando clases
              </div>
              <div className="bg-gray-700 p-4 rounded-lg" data-id="element-47">
                Llevando trabajo a casa
              </div>
              <div className="bg-gray-700 p-4 rounded-lg" data-id="element-48">
                Sintiendo que nunca terminás
              </div>
              <div className="bg-gray-700 p-4 rounded-lg md:col-span-3" data-id="element-49">
                Agotado/a antes de mitad de año
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SOLUTION */}
      <section className="py-16 px-4 bg-white" data-id="element-50">
        <div className="max-w-5xl mx-auto text-center" data-id="element-51">
          <h2 className="text-green-600 font-bold tracking-widest uppercase mb-4" data-id="element-52">
            La solución definitiva
          </h2>
          <h3 className="text-4xl md:text-5xl font-black mb-8" data-id="element-53">
            🇬🇧 MEGAPACK INGLÉS LISTO™
          </h3>
          <p className="text-xl text-gray-600 mb-12 max-w-3xl mx-auto" data-id="element-54">
            Un sistema completo de materiales de INGLÉS, organizados por nivel,
            para que nunca más tengas que empezar de cero.
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12" data-id="element-55">
            {['Todo listo', 'Todo probado', 'Todo ordenado', 'Todo usable'].map(item => <div key={item} className="flex flex-col items-center p-4 bg-green-50 rounded-lg border border-green-200" data-id="element-56">
                  <Check className="w-8 h-8 text-green-600 mb-2" data-id="element-57" />
                  <span className="font-bold text-green-800" data-id="element-58">{item}</span>
                </div>)}
          </div>

          <button onClick={scrollToPurchase} className="bg-[#FF6B35] hover:bg-[#ff5514] text-white text-xl font-bold py-4 px-10 rounded-full shadow-lg hover:shadow-xl transition-all" data-id="element-59">
            👉 QUIERO ACCESO INMEDIATO
          </button>
        </div>
      </section>

      {/* MODULES */}
      <section className="py-16 bg-gray-50 px-4" data-id="element-60">
        <div className="max-w-6xl mx-auto" data-id="element-61">
          <h2 className="text-3xl font-bold text-center mb-12" data-id="element-62">
            ¿Qué incluye el MEGAPACK?
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-63">
            {[{
            title: 'MÓDULO 1',
            items: ['Verb to be', 'Possessive Adjectives', 'Plural', 'Existential There', 'Def. and Indef. Articles']
          }, {
            title: 'MÓDULO 2',
            items: ['Adjectives', 'Comparative', 'Superlative', 'Equative', 'Possessive Pronouns']
          }, {
            title: 'MÓDULO 3',
            items: ['Simple Present', 'Present Continuous', 'Simple Past', 'Simple Future', 'Modal Verbs']
          }, {
            title: 'MÓDULO 4',
            items: ['Reported Speech', 'Zero & First Conditionals', 'Second Conditional']
          }].map((mod, idx) => <div key={idx} className="bg-white p-6 rounded-xl shadow-md border-t-4 border-[#FF6B35]" data-id="element-64">
                <h3 className="font-black text-xl mb-4 text-gray-800" data-id="element-65">
                  {mod.title}
                </h3>
                <ul className="space-y-2" data-id="element-66">
                  {mod.items.map((item, i) => <li key={i} className="flex items-start text-sm text-gray-600" data-id="element-67">
                      <Check className="w-4 h-4 text-[#FF6B35] mr-2 mt-0.5 flex-shrink-0" data-id="element-68" />
                      {item}
                    </li>)}
                </ul>
              </div>)}
          </div>

          <div className="mt-12 text-center bg-blue-50 p-8 rounded-xl border border-blue-200" data-id="element-69">
            <h3 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-70">
              Para todo el sistema educativo
            </h3>
            <div className="flex justify-center gap-8 text-lg font-medium text-blue-800" data-id="element-71">
              <span className="flex items-center" data-id="element-72">
                <span className="text-2xl mr-2" data-id="element-73">🎒</span> Primaria (Inicial)
              </span>
              <span className="flex items-center" data-id="element-74">
                <span className="text-2xl mr-2" data-id="element-75">🎓</span> Secundaria (Media)
              </span>
            </div>
            <p className="mt-4 text-blue-600" data-id="element-76">
              Todo separado por nivel y dificultad.
            </p>
          </div>
        </div>
      </section>

      {/* BENEFITS */}
      <section className="py-16 px-4 bg-white" data-id="element-77">
        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-12" data-id="element-78">
          <div data-id="element-79">
            <h3 className="text-2xl font-bold mb-6 text-[#FF6B35]" data-id="element-80">
              ¿Qué van a lograr tus alumnos?
            </h3>
            <ul className="space-y-4" data-id="element-81">
              {['Entender el inglés paso a paso', 'Participar más en clase', 'Perder el miedo a hablar', 'Aprender jugando', 'Mejorar comprensión y vocabulario', 'Sentirse seguros'].map(item => <li key={item} className="flex items-center bg-orange-50 p-3 rounded-lg" data-id="element-82">
                  <Check className="w-5 h-5 text-[#FF6B35] mr-3" data-id="element-83" />
                  {item}
                </li>)}
            </ul>
          </div>
          <div data-id="element-84">
            <h3 className="text-2xl font-bold mb-6 text-blue-600" data-id="element-85">
              ¿Qué vas a lograr vos?
            </h3>
            <ul className="space-y-4" data-id="element-86">
              {['Ahorrar horas TODAS las semanas', 'Dejar de improvisar', 'Tener respaldo profesional', 'Cubrir el programa completo', 'Dar clases más dinámicas', 'Volver a disfrutar enseñar'].map(item => <li key={item} className="flex items-center bg-blue-50 p-3 rounded-lg" data-id="element-87">
                  <Check className="w-5 h-5 text-blue-600 mr-3" data-id="element-88" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </section>

      {/* BONUSES - DARK SECTION */}
      <section className="py-20 bg-black text-white px-4" data-id="element-89">
        <div className="max-w-6xl mx-auto" data-id="element-90">
          <div className="text-center mb-16" data-id="element-91">
            <span className="bg-[#FF6B35] text-white px-4 py-1 rounded-full font-bold text-sm uppercase tracking-wider" data-id="element-92">
              Regalo Especial
            </span>
            <h2 className="text-4xl md:text-5xl font-black mt-4 mb-4" data-id="element-93">
              🎁 BONOS EXCLUSIVOS – GRATIS SOLO HOY
            </h2>
            <p className="text-xl text-gray-400" data-id="element-94">
              Llevate GRATIS estos 3 bonos premium (Valor total: $147 USD)
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-95">
            {/* Bonus 1 */}
            <div className="bg-gray-900 rounded-xl p-6 border border-gray-800 hover:border-[#FF6B35] transition-colors cursor-pointer" onClick={scrollToPurchase} data-id="element-96">
              <div className="aspect-square bg-gray-800 rounded-lg mb-6 overflow-hidden" data-id="element-97">
                <img src="https://cdn.magicpatterns.com/uploads/tE1EHzsD9bozbtvnw6PSGA/PROYECTOS_Anuales_(8).png" alt="Bono 1" className="w-full h-full object-cover" data-id="element-98" />
              </div>
              <h3 className="text-xl font-bold text-[#FF6B35] mb-2" data-id="element-99">
                🎁 Bono 1 – Clave de respuestas
              </h3>
              <p className="text-gray-400 mb-4" data-id="element-100">
                Todas las soluciones listas para corregir en segundos.
              </p>
              <p className="text-2xl font-bold" data-id="element-101">
                Valor:{' '}
                <span className="line-through text-gray-600" data-id="element-102">$49 USD</span>
              </p>
            </div>

            {/* Bonus 2 */}
            <div className="bg-gray-900 rounded-xl p-6 border border-gray-800 hover:border-[#FF6B35] transition-colors cursor-pointer" onClick={scrollToPurchase} data-id="element-103">
              <div className="aspect-square bg-gray-800 rounded-lg mb-6 overflow-hidden" data-id="element-104">
                <img src="https://cdn.magicpatterns.com/uploads/kvUFXz4F7RkKRt1nyMj5j7/PROYECTOS_Anuales_(9).png" alt="Bono 2" className="w-full h-full object-cover" data-id="element-105" />
              </div>
              <h3 className="text-xl font-bold text-[#FF6B35] mb-2" data-id="element-106">
                🎁 Bono 2 - Ebook y Guias Pdf
              </h3>
              <p className="text-gray-400 mb-4" data-id="element-107">
                Material complementario para profundizar en temas específicos.
              </p>
              <p className="text-2xl font-bold" data-id="element-108">
                Valor:{' '}
                <span className="line-through text-gray-600" data-id="element-109">$49 USD</span>
              </p>
            </div>

            {/* Bonus 3 */}
            <div className="bg-gray-900 rounded-xl p-6 border border-gray-800 hover:border-[#FF6B35] transition-colors cursor-pointer" onClick={scrollToPurchase} data-id="element-110">
              <div className="aspect-square bg-gray-800 rounded-lg mb-6 overflow-hidden" data-id="element-111">
                <img src="https://cdn.magicpatterns.com/uploads/mYE9XNNwBkksd4AwEWdjmz/PROYECTOS_Anuales_(10).png" alt="Bono 3" className="w-full h-full object-cover" data-id="element-112" />
              </div>
              <h3 className="text-xl font-bold text-[#FF6B35] mb-2" data-id="element-113">
                🎁 Bono 3 – Audios Guides
              </h3>
              <p className="text-gray-400 mb-4" data-id="element-114">
                Recursos de audio para practicar listening y pronunciación.
              </p>
              <p className="text-2xl font-bold" data-id="element-115">
                Valor:{' '}
                <span className="line-through text-gray-600" data-id="element-116">$49 USD</span>
              </p>
            </div>
          </div>

          <div className="text-center mt-12 bg-gray-900 p-6 rounded-xl max-w-2xl mx-auto border border-[#FF6B35]" data-id="element-117">
            <p className="text-2xl font-bold mb-2" data-id="element-118">
              🎯 Valor total de los bonos:{' '}
              <span className="line-through text-gray-500" data-id="element-119">$147 USD</span>
            </p>
            <p className="text-3xl font-black text-[#FF6B35]" data-id="element-120">
              👉 GRATIS solo hoy
            </p>
          </div>
        </div>
      </section>

      {/* PRICING / OFFER SECTION */}
      <section id="purchase" className="py-16 px-4 bg-white relative overflow-hidden" data-id="element-121">
        <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-orange-400 via-red-500 to-orange-400" data-id="element-122"></div>

        <div className="max-w-4xl mx-auto text-center" data-id="element-123">
          <div className="mb-8" data-id="element-124">
            <p className="text-red-600 font-bold mb-2 animate-pulse" data-id="element-125">
              ⏰ OFERTA EXPIRA EN:
            </p>
            <CountdownTimer data-id="element-126" />
          </div>

          <div className="bg-white rounded-3xl shadow-2xl border-4 border-[#FF6B35] overflow-hidden" data-id="element-127">
            <div className="bg-[#FF6B35] text-white py-4 px-6" data-id="element-128">
              <h3 className="text-2xl md:text-3xl font-black" data-id="element-129">
                🔥 -74% OFF – SOLO 3 CUPOS
              </h3>
            </div>

            <div className="p-8 md:p-12" data-id="element-130">
              <div className="flex flex-col md:flex-row justify-center items-center gap-8 mb-10" data-id="element-131">
                <div className="text-center" data-id="element-132">
                  <p className="text-gray-500 font-medium mb-1" data-id="element-133">
                    Precio regular
                  </p>
                  <p className="text-3xl text-gray-400 line-through font-bold" data-id="element-134">
                    $49.99 USD
                  </p>
                </div>
                <div className="text-5xl md:text-6xl text-gray-300 hidden md:block" data-id="element-135">
                  →
                </div>
                <div className="text-center transform scale-110" data-id="element-136">
                  <p className="text-[#FF6B35] font-bold mb-1 uppercase tracking-wide" data-id="element-137">
                    Precio HOY
                  </p>
                  <p className="text-5xl md:text-6xl font-black text-gray-900" data-id="element-138">
                    $12.99 USD
                  </p>
                  <p className="text-sm text-gray-500 mt-2" data-id="element-139">
                    (Pagás en la moneda de tu país)
                  </p>
                </div>
              </div>

              <div className="bg-orange-50 rounded-xl p-6 mb-10 text-left max-w-lg mx-auto" data-id="element-140">
                <p className="font-bold text-gray-900 mb-4 text-center border-b border-orange-200 pb-2" data-id="element-141">
                  ✅ Lo que recibís HOY:
                </p>
                <ul className="space-y-3" data-id="element-142">
                  {['Acceso completo de por vida', '+90 recursos + 3 bonos premium', 'Formato fácil y accesible', 'Material Adaptable y versátil', 'Gran ahorro de tiempo', '+80 hojas de teoría', 'Descarga inmediata', '+1k ejercicios', '+380 Worksheets'].map(item => <li key={item} className="flex items-center text-gray-800" data-id="element-143">
                      <Check className="w-5 h-5 text-[#FF6B35] mr-3 flex-shrink-0" data-id="element-144" />
                      {item}
                    </li>)}
                </ul>
              </div>

              <div className="text-center mb-8" data-id="element-145">
                <p className="text-green-600 font-bold text-xl mb-2" data-id="element-146">
                  💰 Ahorrás $37 USD (74%)
                </p>
              </div>

              <a href="https://ingleslisto.edulabs.online/cart/52486117884088:1" className="block w-full bg-[#FF6B35] hover:bg-[#ff5514] text-white text-xl md:text-3xl font-black py-6 px-4 rounded-xl shadow-[0_6px_0_rgb(180,60,20)] hover:shadow-[0_3px_0_rgb(180,60,20)] hover:translate-y-[3px] transition-all mb-6" data-id="element-147">
                SÍ, QUIERO MI ACCESO AHORA
                <span className="block text-sm font-normal mt-1 opacity-90" data-id="element-148">
                  (SOLO 3 CUPOS)
                </span>
              </a>

              <div className="flex flex-col md:flex-row justify-center items-center gap-4 text-sm text-gray-500" data-id="element-149">
                <div className="flex items-center" data-id="element-150">
                  <ShieldCheck className="w-4 h-4 mr-1" data-id="element-151" />
                  Pago 100% seguro y encriptado
                </div>
                <div className="flex items-center" data-id="element-152">
                  <CreditCard className="w-4 h-4 mr-1" data-id="element-153" />
                  Visa – Mastercard
                </div>
                <div className="flex items-center text-orange-600 font-medium" data-id="element-154">
                  <Users className="w-4 h-4 mr-1" data-id="element-155" />3 personas viendo esta
                  oferta ahora
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-156">
        <div className="max-w-6xl mx-auto" data-id="element-157">
          <h2 className="text-3xl font-bold text-center mb-12" data-id="element-158">
            Lo que dicen otros docentes
          </h2>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-159">
            <TestimonialCard name="Laura Fernández" role="Prof. de Inglés" location="Buenos Aires" quote="Ahora tengo todo el año resuelto. Dejé de pasar los domingos planificando." data-id="element-160" />
            <TestimonialCard name="Carlos Méndez" role="Primaria" location="Chile" quote="El material es claro, práctico y adaptable. Mis alumnos participan muchísimo más." data-id="element-161" />
            <TestimonialCard name="Ana García" role="Inicial" location="España" quote="Mis clases cambiaron. Todo está listo y es fácil de usar." data-id="element-162" />
          </div>
        </div>
      </section>

      {/* GUARANTEE */}
      <section className="py-16 px-4 bg-white text-center" data-id="element-163">
        <div className="max-w-3xl mx-auto border-4 border-gray-100 rounded-3xl p-8 md:p-12" data-id="element-164">
          <div className="w-20 h-20 bg-[#FF6B35] rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-165">
            <ShieldCheck className="w-10 h-10 text-white" data-id="element-166" />
          </div>
          <h2 className="text-3xl font-bold mb-4" data-id="element-167">Garantía sin vueltas</h2>
          <p className="text-xl text-gray-600 mb-6" data-id="element-168">
            Tenés 7 días para probarlo. Si no te sirve →{' '}
            <span className="font-bold text-gray-900" data-id="element-169">
              te devolvemos el 100%
            </span>
            .
          </p>
          <p className="text-gray-500" data-id="element-170">
            Sin letra chica. Sin explicaciones. Todo el riesgo es nuestro.
          </p>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-171">
        <div className="max-w-3xl mx-auto" data-id="element-172">
          <h2 className="text-3xl font-bold text-center mb-12" data-id="element-173">
            PREGUNTAS FRECUENTES
          </h2>
          <div className="space-y-4" data-id="element-174">
            {['Material 100% digital', 'Acceso inmediato', 'Sirve para todos los niveles', 'No necesitás experiencia previa', 'Presencial y virtual', 'Acceso de por vida'].map((faq, i) => <div key={i} className="bg-white p-4 rounded-lg shadow-sm flex items-center justify-between" data-id="element-175">
                <span className="font-medium text-gray-800" data-id="element-176">{faq}</span>
                <Check className="w-5 h-5 text-green-500" data-id="element-177" />
              </div>)}
          </div>
        </div>
      </section>

      {/* FOOTER with CTA Button */}
      <footer className="bg-gray-900 text-gray-400 py-12 px-4 text-center text-sm" data-id="element-178">
        <div className="max-w-4xl mx-auto" data-id="element-179">
          {/* Final CTA Button */}
          <div className="mb-8" data-id="element-180">
            <button onClick={scrollToPurchase} className="bg-[#FF6B35] hover:bg-[#ff5514] text-white text-xl md:text-2xl font-black py-5 px-10 rounded-lg shadow-[0_6px_0_rgb(180,60,20)] hover:shadow-[0_3px_0_rgb(180,60,20)] hover:translate-y-[3px] transition-all" data-id="element-181">
              🔥 OBTENER MI MEGAPACK AHORA
              <span className="block text-sm font-normal mt-1 opacity-90" data-id="element-182">
                Última oportunidad - Solo 3 cupos
              </span>
            </button>
          </div>

          <p className="mb-4" data-id="element-183">
            © 2024 Megapack Inglés Listo. Todos los derechos reservados.
          </p>
          <p className="text-xs text-gray-600" data-id="element-184">
            This site is not a part of the Facebook website or Facebook Inc.
            Additionally, This site is NOT endorsed by Facebook in any way.
            FACEBOOK is a trademark of FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </div>;
}